import React from 'react';
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
  DotGroup,
} from 'pure-react-carousel';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import FirmCarouselSlide from './components/FirmCarouselSlide';
import 'pure-react-carousel/dist/react-carousel.es.css';

import './styles.css';

const FullWidthCarousel = props => {
  const { title, items, onRatingUpdate, onBeforeRatingUpdate } = props;

  return (
    <div className="fullwidth-carousel__wrapper">
      <h3 className="fullwidth-carousel__title">{title}</h3>

      <MediaQuery query="(min-width: 768px)">
        <CarouselProvider
          className="fullwidth-carousel"
          naturalSlideWidth={100}
          naturalSlideHeight={125}
          totalSlides={items.length}
          visibleSlides={2}
          infinite={true}
          dragEnabled={false}
        >
          <Slider className="fullwidth-carousel__slider">
            {items.map((item, index) => {
              return (
                <Slide index={index} key={index}>
                  <FirmCarouselSlide
                    data={item}
                    onBeforeRatingUpdate={onBeforeRatingUpdate}
                    onRatingUpdate={onRatingUpdate}
                  />
                </Slide>
              );
            })}
          </Slider>

          <ButtonBack className="fullwidth-carousel__button fullwidth-carousel__button--back">
            <span className="fullwidth-carousel__icon fullwidth-carousel__icon--back" />
          </ButtonBack>
          <ButtonNext className="fullwidth-carousel__button fullwidth-carousel__button--next">
            <span className="fullwidth-carousel__icon fullwidth-carousel__icon--next" />
          </ButtonNext>
        </CarouselProvider>
      </MediaQuery>

      <MediaQuery query="(max-width: 767px)">
        <CarouselProvider
          className="fullwidth-carousel fullwidth-carousel--mobile"
          naturalSlideWidth={100}
          naturalSlideHeight={100}
          totalSlides={items.length}
          visibleSlides={1}
          infinite={true}
          dragEnabled={true}
          orientation="horizontal"
        >
          <Slider className="fullwidth-carousel__slider fullwidth-carousel__slider--mobile">
            {items.map((item, index) => {
              return (
                <Slide index={index} key={index}>
                  <FirmCarouselSlide
                    data={item}
                    onBeforeRatingUpdate={onBeforeRatingUpdate}
                    onRatingUpdate={onRatingUpdate}
                  />
                </Slide>
              );
            })}
          </Slider>

          <DotGroup className="fullwidth-carousel__dots" />
        </CarouselProvider>
      </MediaQuery>
    </div>
  );
};

FullWidthCarousel.propTypes = {
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  onRatingUpdate: PropTypes.func.isRequired,
  onBeforeRatingUpdate: PropTypes.func.isRequired,
};

export default FullWidthCarousel;
